document.addEventListener("DOMContentLoaded", function() {

	let trap = false;

	//Footer signup
	var newsletter_shortcut = document.getElementById("fluentform_newsletter_shortcut");
	if (newsletter_shortcut) {
		newsletter_shortcut.onsubmit = function onSubmit(form) {
			//prevent default submission
			form.preventDefault();

			//fetch the subscription modal
			let subscription_modal = document.getElementById('subscription-modal');

			//store email from shortcut bar
			let email = form.target.elements.email.value;

			//if we've not initialized the focus trap
			if(!trap) {
				const focusTrap = require('focus-trap');
				trap = focusTrap.createFocusTrap(subscription_modal);
			}

			//if we have an email and it's not blank
			if(email && email != "") {

				//activate the trap
				trap.activate();

				let email_field = document.querySelector('#subscription-modal #mce-EMAIL');

				if(email_field) {
					email_field.focus();
				}

				//if the modal exists
				if(subscription_modal) {
					//toggle the modal
					subscription_modal.classList.add('open');

					//add an event listener for the close button
					subscription_modal.addEventListener('click', function (event) {

						// If the clicked element isn't the close button menu, return
						if (!event.target.matches('#subscription-modal-close')) return;

						//deactivate the focus trap
						trap.deactivate();
				
						//close the model
						subscription_modal.classList.remove('open');
					}, false);

					//attempt to find the email field
					let modal_email = document.querySelector("#subscription-modal #mce-EMAIL");

					//if we've found it
					if(modal_email) {

						//populate it with the value from the shortcut
						modal_email.value = email;
					}
				}
			}

			//listen for keypress events inside the modal
			subscription_modal.onkeydown = function(event) {

				//if the escape key is pressed
				if (event.keyCode == 27) {
					
					//deactivate the focus trap
					trap.deactivate();
				
					//close the model
					subscription_modal.classList.remove('open');
				}
			}
		}
	}


	//button signup trigger
	let newssignup = document.querySelector('.newsletter-signup');	

	if (newssignup) {

		newssignup.addEventListener('click', function(event) {

			event.preventDefault();

			//fetch the subscription modal
			let subscription_modal = document.getElementById('subscription-modal');

			//if we've not initialized the focus trap
			if(!trap) {
				const focusTrap = require('focus-trap');
				trap = focusTrap.createFocusTrap(subscription_modal);
			}


			//activate the trap
			trap.activate();

			let email_field = document.querySelector('#subscription-modal #mce-EMAIL');

			if(email_field) {
				email_field.focus();
			}

			//if the modal exists
			if(subscription_modal) {
				//toggle the modal
				subscription_modal.classList.add('open');

				//add an event listener for the close button
				subscription_modal.addEventListener('click', function (event) {

					// If the clicked element isn't the close button menu, return
					if (!event.target.matches('#subscription-modal-close')) return;

					//deactivate the focus trap
					trap.deactivate();
			
					//close the model
					subscription_modal.classList.remove('open');
				}, false);

			}
			
			//listen for keypress events inside the modal
			subscription_modal.onkeydown = function(event) {

				//if the escape key is pressed
				if (event.keyCode == 27) {
					
					//deactivate the focus trap
					trap.deactivate();
				
					//close the model
					subscription_modal.classList.remove('open');
				}
			}
		});
	}

});